import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { I18N, GlobalContext } from 'commons';
import FieldSection from 'components/forms/FieldSection';
import UserNameFieldSection from 'components/forms/UserNameFieldSection';
import PasswordSection from 'components/forms/my-profile/PasswordSection';
import SecurityQuestionSection from 'components/forms/my-profile/SecurityQuestionSection';
import DropDownWithLabel from 'components/forms/DropDownWithLabel';


const MyProfileSection = ({
  values, touched, errors, resetLocationValues, setFieldValue, setFieldTouched, setFieldError, preferredLanguage, shouldShowPreferredLanguage, preferredLanguageList=[]
}) => {
  const { organization: { userStatus, isFedRAMPCustomer, editFirstName, editLastName}, account: { ssoIdentity } } = useContext(GlobalContext);
  return (
    <div className="col-md-12">
      <div className="form-group row">
        <FieldSection
          className="col-md-4"
          name="firstName"
          title="ssp.register.firstname"
          maxLength="100"
          isDisable={!editFirstName}
          autoComplete="given-name"
          {...{ values, touched, errors }}
        />
        <FieldSection
          className="col-md-4"
          name="lastName"
          title="ssp.register.lastname"
          maxLength="100"
          isDisable={!editLastName}
          autoComplete="family-name"
          {...{ values, touched, errors }}
        />
      </div>
      {
        ssoIdentity &&
        <div className="form-group row">
          <div className="col-md-8">
            <label className="col-form-label" htmlFor="ssoid">
              <I18N>sso.signin.user.id</I18N>
            </label>
            <div id="ssoid">
              <span>{ssoIdentity}</span>
            </div>
          </div>
        </div>
      }
      <div className="form-group row">
        <UserNameFieldSection
          className="col-md-8"
          name="username"
          title="ssp.register.username"
          maxLength="80"
          minLength="4"
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          setFieldError={setFieldError}
          autoComplete="username"
          {...{ values, touched, errors }}
        />
        <div id="usernameTip" className="form-text col-md-4 small align-self-end">
          <I18N>signup.4AcceptableCharacters</I18N>
        </div>
      </div>
      <div className="form-group row">
        <PasswordSection {...{ values, touched, errors }} />
        <div className="col-md-4 align-self-end">
          <div id="passwordTip" className="form-text small ">
            {!isFedRAMPCustomer && userStatus === 'public'
            && <I18N>aware.register.passwordNotice</I18N>}
            {!isFedRAMPCustomer && userStatus === 'private'
            && <I18N>aware.register.passwordNotice2</I18N>}
            {isFedRAMPCustomer && <I18N>aware.register.passwordNotice.fedRamp</I18N>}
          </div>
        </div>
      </div>
      {
        (shouldShowPreferredLanguage && preferredLanguageList.length > 0) &&
        <div className="form-group row">
          <FieldSection
              className="col-md-8"
              name="preferredLanguage"
              title="ssp.register.preferredLanguage"
              component={()=>(<DropDownWithLabel
                defaultValue={preferredLanguage}
                list={preferredLanguageList}
                {...{ values, touched, errors }}
              />)}
              {...{ values, touched, errors }}
          />
        </div>
      }
      
      <div className="form-group row">
        <SecurityQuestionSection
          securityQuestion={values.securityQuestion}
          resetLocationValues={resetLocationValues}
          {...{ values, touched, errors }}
        />
      </div>
      <div className="form-group row">
        <FieldSection
          className="col-md-8"
          name="securityAnswer"
          title="aware.register.answer"
          maxLength="120"
          {...{ values, touched, errors }}
        />
      </div>
    </div>
  );
};

MyProfileSection.propTypes = {
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
};

export default MyProfileSection;
